import mori from 'mori';

/**
 * [getApplicableFootnotes description]
 * @TODO finish building out this doc
 * @param  {[type]} footnotes     [description]
 * @param  {[type]} row           [description]
 * @param  {[type]} keys          [description]
 * @param  {[type]} select        [description]
 * @param  {[type]} timeframe     [description]
 * @param  {[type]} distributions [description]
 * @return {[type]}               [description]
 */
export default function(
  footnotes,
  row,
  keys,
  select,
  timeframe,
  distributions
) {
  const footnotesForTimeframe = mori.reduce(
    (acc, curr) => mori.hasKey(acc, mori.first(curr)) ?
      mori.conj(
        acc,
        mori.assoc(
          acc,
          mori.first(curr),
          mori.reduce(
            (acc1, curr1) => mori.hasKey(acc1, mori.first(mori.first(curr1))) ?
              mori.updateIn(
                acc1,
                [mori.first(mori.first(curr1))],
                () => mori.flatten(mori.into(
                  mori.get(acc1, mori.first(mori.first(curr1))),
                  mori.rest(mori.first(curr1))
                ))
              ) :
              mori.conj(acc1, curr1),
            mori.get(acc, mori.first(curr)),
            mori.rest(curr)
          )
        )
      ) :
      mori.conj(acc, curr),
    mori.get(footnotes, 'any', mori.hashMap()),
    mori.get(footnotes, mori.first(timeframe), mori.hashMap())
  );

  let foundFootnotes = mori.getIn(
    footnotesForTimeframe,
    [mori.get(row, mori.first(keys)), mori.first(select)],
    mori.vector()
  );

  if (mori.some(
    (curr) => mori.get(curr, 'headerGroup') === mori.first(select),
    distributions
  )) {
    foundFootnotes = mori.flatten(mori.conj(
      foundFootnotes,
      mori.getIn(
        footnotesForTimeframe,
        [mori.get(row, mori.first(keys)), mori.first(mori.rest(select))],
        mori.vector()
      ),
      mori.getIn(
        footnotesForTimeframe,
        [mori.get(row, mori.first(keys)), mori.hashMap(
          mori.first(select), mori.first(mori.rest(select))
        )],
        mori.vector()
      )
    ));
  }

  return mori.toJs(foundFootnotes);
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/services/table/getApplicableFootnotes.js
 **/